import z from 'zod';

export type DecimalRange = {
	minimum: number | null;
	maximum: number | null;
};

export const DecimalRangeSchema: z.ZodType<DecimalRange> = z.object({
	minimum: z.number().nullable(),
	maximum: z.number().nullable(),
});
